import { CdkTrapFocus } from '@angular/cdk/a11y';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

import { DIALOG_DATA } from '@treetop/shared/model';

import { ButtonDirective } from '../button/button.directive';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { DialogRef } from '../dialog/dialog-ref';

export interface TranslationParams {
  [x: string]: string;
}

export type ConfirmationDialogArgs = {
  message: string;
  component?: string;
  params?: TranslationParams;
  cancelButtonCaption: string;
  confirmButtonCaption: string;
  checkboxText?: string;
  hintText?: string;
  additionalParams?: string[][];
  confirmButtonTestId?: string;
  buttonVariant?: 'default' | 'destructive';
};

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [MatIconModule, TranslocoPipe, FormsModule, CdkTrapFocus, ButtonDirective, CheckboxComponent],
})
export class ConfirmationDialogComponent {
  private dialogRef: DialogRef = inject(DialogRef);
  public data: ConfirmationDialogArgs = inject(DIALOG_DATA) as ConfirmationDialogArgs;

  isChecked: boolean;

  protected closeDialog(valueClosed: boolean): void {
    this.dialogRef.close(valueClosed);
  }

  protected closeDialogNoAction(): void {
    this.dialogRef.close(null);
  }
}
